export default __webpack_public_path__ + "99e07b0f8ce963d4602c20baa9b090be.svg";